import React from "react";

// Components
import { Header } from './orderDetailsHeader.style';


export const OrderDetailsHeader = () => {
    return (
        <Header>
            <span>
                Detalhes do pedido
            </span>
        </Header>
    )
}